module.exports = __webpack_public_path__ + "static/media/sword-2b.f23a64c9.glb";